export default __webpack_public_path__ + "static/media/cover.9d1bca2c.jpg";